import React from 'react';

const Info = () => {
  return (
    <div className="about__info grid">
        <div className="about__box">
            <h3 className="about__title"></h3>
            <span className="about__subtitle"></span>
        </div>
        <div className="about__box">
            <h3 className="about__title"></h3>
            <span className="about__subtitle"></span>
        </div>
        <div className="about__box">
            <h3 className="about__title"></h3>
            <span className="about__subtitle"></span>
        </div>
    </div>
  )
}

export default Info;